import { DomainV2 } from 'troppus-common/domain';

import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;

const LABEL_BY_LOAD_MODE: Record<ImportTableDefinition.LoadMode, string> = {
  Upsert: 'Upsert（同一キーは更新）',
  Replace: '洗い替え',
};

export function importTableDefinitionLoadModeLabel(mode: ImportTableDefinition.LoadMode): string {
  return LABEL_BY_LOAD_MODE[mode];
}
